/**
 * Analytics — Attractions API Contracts
 *
 * Wire format for AnalyticsAttractionsController.
 *
 * NOTE: This endpoint is a stub — the service currently returns placeholder data.
 * Schemas are defined here for completeness and will be fleshed out when the
 * feature is implemented.
 */

import { z } from 'zod';

const DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export const AttractionVisitsQuerySchema = z.object({
  dateFrom: z.string().regex(DATE_REGEX).optional(),
  dateTo: z.string().regex(DATE_REGEX).optional(),
});
export type AttractionVisitsQuery = z.infer<typeof AttractionVisitsQuerySchema>;

export const AttractionVisitsResponseSchema = z.object({
  message: z.string(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
});
export type AttractionVisitsResponse = z.infer<typeof AttractionVisitsResponseSchema>;
